'use strict';

(function () {
  'use strict';

  angular.module('msWriteOnly').controller('WriteOnlySleepEntryCtrl', WriteOnlySleepEntryCtrl);

  WriteOnlySleepEntryCtrl.$inject = ['$stateParams', '$log', 'eventTrackingSvc'];

  /* @ngInject */
  function WriteOnlySleepEntryCtrl($stateParams, $log, eventTrackingSvc) {
    var vm = this;
    vm.day = moment($stateParams.day).format('YYYY-MM-DD');
    vm.showCalendarOverlay = false;
    vm.showSummary = false;
    vm.loginUrl = $stateParams.loginUrl && $stateParams.loginUrl.length > 0 ? $stateParams.loginUrl : '/login';

    vm.continue = function () {
      window.location = '/login/';
    };
    vm.entryComplete = function (day, entryData) {
      eventTrackingSvc.fireEvent('sleepTool', 'diaryEntry', 'loggedOut');
      vm.showSummary = true;
      vm.entry = entryData.entries[day];
    };
    vm.updateDay = function (day) {
      vm.day = day;
      vm.showCalendarOverlay = !vm.showCalendarOverlay;
    };
    vm.$onInit = activate;

    ////////////////
    function activate() {
      $log.debug('WriteOnlySleepEntryCtrl activate');
    }
  }
})();